export const toAbsoluteUrl = (path) => {
  return `${process.env.PUBLIC_URL}${path}`;
};
